import { createEventDispatcher } from "svelte";
/*                                                         */
/*         */
/*                                 */
import { get_current_component } from "svelte/internal";

/**
 *
 *
 *
 *
 *
 */
export type PropertyChangeDetail<Props = Record<string, unknown>> = {
  [P in keyof Props]?: {
    /*                               */
    previous: Props[P];
    /*                             */
    current: Props[P];
  };
};

type AnyPropertyChangeDetail = PropertyChangeDetail<Record<string, unknown>>;

export type PropertyChangeEvent<Props = Record<string, unknown>> = CustomEvent<
  PropertyChangeDetail<Props>
>;

/**
 *
 */
export type PropertyChangeListener<Props = Record<string, unknown>> = (
  this: HTMLElement,
  ev: PropertyChangeEvent<Props>,
) => void;

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function usePropertyChange(): void {
  const dispatch = createEventDispatcher<{ "property-change": AnyPropertyChangeDetail }>();

  /*                                                         */
  let initialized = false;

  /*                                                                       */
  const lastState: Record<string, unknown> = {};
  const component = get_current_component();

  component.$$.after_update.push(() => {
    const { props, ctx } = component.$$;

    /*                                  */
    const changes: AnyPropertyChangeDetail = {};
    Object.entries(props).forEach(([key, ctxIndex]) => {
      if (lastState[key] === ctx[ctxIndex]) return;

      /*                                    */
      changes[key] = { previous: lastState[key], current: ctx[ctxIndex] };
      lastState[key] = ctx[ctxIndex];
    });

    /*                                                                                      */
    /*              */
    if (!initialized) {
      initialized = true;
      return;
    }

    /*                                                          */
    dispatch("property-change", changes);
  });
}
